import Input from "./Input";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import Checkbox from "./Checkbox";
import Textarea from "./Textarea";
// import DatePicker from "./DatePicker";
import Button from "./Button";
import ActionButton from "./ActionButton";

const Controls = {
    Input,
    RadioGroup,
    Select,
    Checkbox,
    Textarea,
    Button,
    ActionButton
}

export default Controls;